module.exports = __webpack_public_path__ + "static/media/temp-persona-12.51e89135.jpg";